export const mostrarErrorGenerico = (errorData, setProcessing, setAlertConfig, setShowAlert) => {
    const { mensaje } = errorData;

    setProcessing(false);

    setAlertConfig({
      type: "error",
      title: "¡Advertencia!",
      message: mensaje,
      onConfirm: () => {
        setShowAlert(false);
      },
    });

    setShowAlert(true);
  };